/* RB Accessibility menu (Oct 20, 2026). Markup: snippets/rb-a11y.liquid. Styles and display modes: assets/rb-a11y.css.
   Settings live in localStorage 'rb_a11y' ({fs, contrast, spacing, font, links, headings, motion, cursor, focus, guide})
   and are applied as classes on <html>; the early script in the snippet applies the CSS-only ones before paint.
   Text size: every element that holds text gets an inline font-size of its own size × the chosen factor, measured
   once before any change, so nested text never compounds. New content (cart drawer, search, popups) is scaled as it
   appears, and everything is re-measured when the window width changes (phones rotate, breakpoints).
   Oct 21, 2026, sprint 2: the widget is now the last thing in <body> (audit F2) and rb-a11y.css loads after the first
   paint (S5), so the button is shown only once that stylesheet is in; closing the panel returns focus to whatever
   opened it (the button, the "open the accessibility menu" skip link at the top, or a footer link). */
(function () {
  if (window.__rbA11y) return;
  window.__rbA11y = true;

  var root = document.querySelector('[data-rb-a11y]');
  if (!root) return;
  var fab = document.getElementById('rb-a11y-fab');
  var dlg = document.getElementById('rb-a11y-dialog');
  var html = document.documentElement;
  var T = {};
  try { T = JSON.parse(root.querySelector('[data-rb-a11y-strings]').textContent); } catch (e) {}

  var KEY = 'rb_a11y';
  var TOGGLES = ['spacing', 'font', 'links', 'headings', 'motion', 'cursor', 'focus', 'guide'];
  var CONTRASTS = ['dark', 'light', 'mono'];
  var SIZES = [1, 1.2, 1.4, 1.6, 1.8, 2];
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { state = {}; }
  var save = function () {
    var clean = {};
    Object.keys(state).forEach(function (k) { if (state[k]) clean[k] = state[k]; });
    try { if (Object.keys(clean).length) localStorage.setItem(KEY, JSON.stringify(clean)); else localStorage.removeItem(KEY); } catch (e) {}
  };

  /* ---------- text size ---------- */
  var SKIP = 'script,style,noscript,template,svg,iframe,video,img,picture,source,br,hr,canvas,.rb-a11y,.rb-a11y *';
  var factor = 1;
  var hasText = function (el) {
    var n = el.firstChild;
    while (n) { if (n.nodeType === 3 && n.nodeValue.trim()) return true; n = n.nextSibling; }
    return /^(INPUT|SELECT|TEXTAREA|BUTTON|OPTION)$/.test(el.tagName);
  };
  var targets = function (scope) {
    var list = [];
    var all = scope.querySelectorAll ? scope.querySelectorAll('*') : [];
    if (scope.nodeType === 1 && scope !== document.body) list.push(scope);
    for (var i = 0; i < all.length; i++) list.push(all[i]);
    return list.filter(function (el) { return !el.matches(SKIP) && hasText(el); });
  };
  var scaledParent = function (el) {
    var p = el.parentElement;
    while (p && p !== document.body) { if (p.hasAttribute('data-rb-fs')) return p; p = p.parentElement; }
    return null;
  };
  var scale = function (scope) {
    if (factor === 1) return;
    var els = targets(scope).filter(function (el) { return !el.hasAttribute('data-rb-fs'); });
    // read everything first, then write, so no measurement sees an already enlarged parent
    var orig = els.map(function (el) {
      var px = parseFloat(getComputedStyle(el).fontSize) || 16;
      var sp = scaledParent(el);
      if (sp && Math.abs(parseFloat(getComputedStyle(sp).fontSize) - px) < 0.1) px = parseFloat(sp.getAttribute('data-rb-fs'));
      return px;
    });
    els.forEach(function (el, i) {
      el.setAttribute('data-rb-fs', orig[i]);
      var inl = el.style.getPropertyValue('font-size');
      if (inl) el.setAttribute('data-rb-fs-inline', inl);
      el.style.setProperty('font-size', (orig[i] * factor).toFixed(2) + 'px', 'important');
    });
  };
  var unscale = function () {
    document.querySelectorAll('[data-rb-fs]').forEach(function (el) {
      var inl = el.getAttribute('data-rb-fs-inline');
      el.style.removeProperty('font-size');
      if (inl) el.style.setProperty('font-size', inl);
      el.removeAttribute('data-rb-fs');
      el.removeAttribute('data-rb-fs-inline');
    });
  };
  var mo = null;
  var queue = [];
  var flush = function () {
    var q = queue; queue = [];
    q.forEach(function (n) { if (n.isConnected) scale(n); });
  };
  var setSize = function (level) {
    level = Math.max(0, Math.min(SIZES.length - 1, level | 0));
    state.fs = level;
    unscale();
    factor = SIZES[level];
    html.classList.toggle('rb-a11y-fs', level > 0);
    if (level > 0) {
      scale(document.body);
      if (!mo && 'MutationObserver' in window) {
        mo = new MutationObserver(function (records) {
          records.forEach(function (r) {
            r.addedNodes.forEach(function (n) {
              if (n.nodeType === 1 && !n.closest('.rb-a11y')) queue.push(n);
              else if (n.nodeType === 3 && n.parentElement && !n.parentElement.closest('.rb-a11y')) queue.push(n.parentElement);
            });
          });
          if (queue.length) setTimeout(flush, 0);
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
    } else if (mo) { mo.disconnect(); mo = null; }
    var pct = Math.round(factor * 100) + '%';
    var out = root.querySelector('[data-rb-a11y-fs-now]');
    if (out) out.textContent = pct;
    root.querySelectorAll('[data-rb-a11y-fs]').forEach(function (b) {
      var d = Number(b.getAttribute('data-rb-a11y-fs'));
      var off = (d < 0 && level === 0) || (d > 0 && level === SIZES.length - 1);
      b.setAttribute('aria-disabled', off ? 'true' : 'false');
    });
  };
  var lastW = window.innerWidth;
  var rt = 0;
  window.addEventListener('resize', function () {
    if (factor === 1 || Math.abs(window.innerWidth - lastW) < 40) return;
    clearTimeout(rt);
    rt = setTimeout(function () { lastW = window.innerWidth; setSize(state.fs); }, 250);
  });

  /* ---------- stop animations and videos ---------- */
  var stopVideos = function (on) {
    document.querySelectorAll('video').forEach(function (v) {
      if (on) {
        if (!v.paused || v.autoplay) v.setAttribute('data-rb-a11y-paused', '');
        v.dataset.rbStopped = '1';   // rb-brand.js will not restart it
        v.autoplay = false;
        v.pause();
      } else if (v.hasAttribute('data-rb-a11y-paused')) {
        v.removeAttribute('data-rb-a11y-paused');
        delete v.dataset.rbStopped;
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
    });
  };

  /* ---------- reading guide ---------- */
  var guide = null;
  var moveGuide = function (e) { if (guide) guide.style.transform = 'translateY(' + (e.clientY - 6) + 'px)'; };
  var setGuide = function (on) {
    if (on && !guide) {
      guide = document.createElement('div');
      guide.className = 'rb-a11y__guide';
      guide.setAttribute('aria-hidden', 'true');
      root.appendChild(guide);   // inside the widget, so no display mode touches it
      document.addEventListener('pointermove', moveGuide, { passive: true });
    } else if (!on && guide) {
      document.removeEventListener('pointermove', moveGuide);
      guide.remove();
      guide = null;
    }
  };

  /* ---------- apply ---------- */
  var applyToggle = function (k) {
    var on = state[k] === 1;
    html.classList.toggle('rb-a11y-' + k, on);
    if (k === 'motion') stopVideos(on);
    if (k === 'guide') setGuide(on);
    var b = root.querySelector('[data-rb-a11y-t="' + k + '"]');
    if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
  };
  var applyContrast = function () {
    CONTRASTS.forEach(function (c) {
      html.classList.toggle('rb-a11y-' + c, state.contrast === c);
      var b = root.querySelector('[data-rb-a11y-contrast="' + c + '"]');
      if (b) b.setAttribute('aria-pressed', state.contrast === c ? 'true' : 'false');
    });
  };
  var applyAll = function () {
    TOGGLES.forEach(applyToggle);
    if (CONTRASTS.indexOf(state.contrast) < 0) state.contrast = '';
    applyContrast();
    setSize(state.fs || 0);
  };

  /* ---------- panel ---------- */
  var status = root.querySelector('[data-rb-a11y-status]');
  var say = function (msg) {
    if (!status) return;
    status.textContent = '';
    setTimeout(function () { status.textContent = msg; }, 60);
  };
  var isOpen = function () { return dlg.hasAttribute('open'); };
  var opener = null;
  // shown: rb-a11y.css is in (see the end of this file). The skip link or a footer link can ask for the panel before
  // that; it then opens the moment the stylesheet arrives (or after 4 s at most), never unstyled (review, sprint 2).
  var shown = false, pending = false;
  var open = function () {
    if (isOpen()) return;
    if (!shown) { pending = true; return; }
    var a = document.activeElement;
    opener = (a && a !== document.body && a !== fab && !root.contains(a)) ? a : null;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    fab.setAttribute('aria-expanded', 'true');
    var first = dlg.querySelector('[data-rb-a11y-close]');
    if (first) first.focus();
  };
  var close = function () {
    if (!isOpen()) return;
    if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
  };
  dlg.addEventListener('close', function () {
    fab.setAttribute('aria-expanded', 'false');
    // back to the element that opened the panel, if it is still on the page; otherwise the button
    var back = opener && opener.isConnected && opener.getClientRects().length ? opener : fab;
    opener = null;
    try { back.focus(); } catch (e) {}
  });
  // click on the dimmed area outside the panel closes it
  dlg.addEventListener('click', function (e) {
    if (e.target !== dlg) return;
    var r = dlg.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
  });
  if (!dlg.showModal) {
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  }

  fab.addEventListener('click', function () { if (isOpen()) close(); else open(); });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-rb-a11y-close')) { close(); return; }
    if (t.hasAttribute('data-rb-a11y-fs')) {
      if (t.getAttribute('aria-disabled') === 'true') return;
      setSize((state.fs || 0) + Number(t.getAttribute('data-rb-a11y-fs')));
      save();
      say((T.sizeNow || '[n]%').replace('[n]', Math.round(factor * 100)));
      return;
    }
    var k = t.getAttribute('data-rb-a11y-t');
    if (k) { state[k] = state[k] === 1 ? 0 : 1; applyToggle(k); save(); return; }
    var c = t.getAttribute('data-rb-a11y-contrast');
    if (c) { state.contrast = state.contrast === c ? '' : c; applyContrast(); save(); return; }
    if (t.hasAttribute('data-rb-a11y-reset')) {
      TOGGLES.forEach(function (key) { state[key] = 0; });
      state.contrast = '';
      state.fs = 0;
      applyAll();
      save();
      say(T.resetDone || '');
      return;
    }
    if (t.hasAttribute('data-rb-a11y-report')) {
      // the mail opens with the page address already filled in
      var href = t.getAttribute('href').split('?')[0];
      t.setAttribute('href', href + '?subject=' + encodeURIComponent(T.mailSubject || '') +
        '&body=' + encodeURIComponent((T.mailBody || '').replace('[url]', location.href.split('#')[0])));
    }
  });

  // show the button once rb-a11y.css has arrived (it sets --rb-a11y-ready on the wrapper); never wait longer than 4 s
  var show = function () {
    if (shown) return;
    shown = true;
    fab.hidden = false;
    if (pending) { pending = false; open(); }
  };
  var ready = function () {
    try { return getComputedStyle(root).getPropertyValue('--rb-a11y-ready').trim() === '1'; } catch (e) { return true; }
  };
  if (ready()) show();
  else {
    var sheet = document.getElementById('rb-a11y-css');
    if (sheet) { sheet.addEventListener('load', show); sheet.addEventListener('error', show); }
    setTimeout(show, 4000);
  }
  applyAll();
  window.RBA11y = { open: open, close: close };
  // any link to #accessibility (e.g. in the footer) opens the menu
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#accessibility"]');
    if (!a) return;
    e.preventDefault();
    open();
  });
})();
